import { format, startOfMonth, endOfMonth, subMonths } from "date-fns"

// ---------- dates ----------
export const ymd = d => format(new Date(d), "yyyy-MM-dd")

export const monthBounds = preset => {
  const base = preset === "this" ? new Date() : subMonths(new Date(), 1)
  return { start: startOfMonth(base), end: endOfMonth(base) }
}

export const isMonth = (range, preset) => {
  if (!range || !range.start || !range.end) return false
  const b = monthBounds(preset)
  return ymd(range.start) === ymd(b.start) && ymd(range.end) === ymd(b.end)
}

export function getEstimatedDate (days = 7) {
  const date = new Date()
  date.setDate(date.getDate() + days)
  return `<div>${format(date, "dd.MM.yyyy")}</div>`
}

// ---------- strings ----------
export const norm = s => (s || "").toLowerCase().replace(/\s+/g, "")

// ---------- query params ----------
export const buildDateRangeParams = ({ dateRange, rar }) => ({
  ...(dateRange && dateRange.start && { from: ymd(dateRange.start) }),
  ...(dateRange && dateRange.end   && { to:   ymd(dateRange.end) }),
  ...(rar                          && { rar })
})
